//import Libraries
import React from 'react'
import {Link} from 'react-router-dom';

//import Components

//import Styles
import './DetailButton.css';

const detailButton = (props) => {
    
    const renderText = '제품 상세정보';

    return(
        <div>
            <span>
                {props.showText && renderText}
            </span>
            <span>
                <button className='to-detail-btn' onClick={() => {
                    console.log('move to link');
                }}>To Detail</button>
           </span>
        </div>
    );
}

export default detailButton;


// WEBPACK FOOTER //
// ./src/pages/Store/Props/DetailButton.js